import { createContext, useContext, useState, useEffect } from 'react';

// Translation strings
const translations = {
  ar: {
    // Navigation
    nav: {
      services: 'خدمات',
      realEstate: 'عقارات',
      marketplace: 'السوق',
      spareParts: 'قطع غيار',
      products: 'متجر',
      login: 'تسجيل دخول',
      register: 'إنشاء حساب',
      dashboard: 'لوحة التحكم',
      logout: 'تسجيل خروج'
    },
    // Home page
    home: {
      heroTitle: 'خدماتك في مكان واحد',
      heroSubtitle: 'منصتك الشاملة لكل ما تحتاجه في مكان واحد',
      getStarted: 'ابدأ الآن',
      learnMore: 'اعرف المزيد',
      exploreCategories: 'استكشف الأقسام',
      exploreCategoriesSubtitle: 'اكتشف مجموعة متنوعة من الخدمات والمنتجات',
      featuredServices: 'خدماتنا المميزة',
      whyChooseUs: 'لماذا تختارنا؟',
      merchantTitle: 'هل أنت تاجر؟',
      merchantSubtitle: 'انضم لـ CloudGM Business وصل لآلاف العملاء',
      joinBusiness: 'انضم لـ CloudGM Business',
      servicesTitle: 'الخدمات المهنية',
      servicesDesc: 'حلول شاملة لجميع احتياجاتك',
      realEstateTitle: 'العقارات والأراضي',
      realEstateDesc: 'اكتشف عقارات وأراضي مميزة في الإمارات',
      storeTitle: 'المتجر الإلكتروني',
      storeDesc: 'تسوق من مجموعة واسعة من المنتجات عالية الجودة',
      marketplaceTitle: 'مركز السوق',
      marketplaceDesc: 'أرقام موبايل، سيارات، ولوحات مميزة',
      sparePartsTitle: 'قطع غيار السيارات',
      sparePartsDesc: 'قطع غيار عالية الجودة لجميع أنواع السيارات'
    },
    // Services
    services: {
      title: 'الخدمات الحكومية',
      subtitle: 'Government Services',
      description: 'خدمات حكومية متكاملة بأعلى معايير الجودة',
      visa: 'خدمات التأشيرة والهوية الإماراتية',
      translation: 'الترجمة القانونية',
      documents: 'تخليص المستندات',
      companyFormation: 'تأسيس الشركات',
      subscriptionPackages: 'باقات الاشتراك',
      monthly: 'شهرياً',
      yearly: 'سنوياً',
      subscribe: 'اشترك الآن',
      mostPopular: 'الأكثر طلباً',
      recommended: 'موصى به',
      save: 'وفر',
      exploreService: 'استكشف الخدمة',
      comingSoon: 'قريباً',
      requestService: 'طلب خدمة',
      serviceType: 'نوع الخدمة',
      requestTitle: 'عنوان الطلب',
      details: 'التفاصيل',
      name: 'الاسم',
      submitRequest: 'إرسال الطلب',
      submitting: 'جاري الإرسال...',
      packageFeatures: 'مميزات الباقة',
      confirmSubscription: 'تأكيد الاشتراك',
      fullNameOrCompany: 'الاسم الكامل / اسم الشركة',
      subscribeIn: 'الاشتراك في'
    },
    // Marketplace
    marketplace: {
      title: 'السوق',
      subtitle: 'MarketPlace',
      description: 'اكتشف سوقنا الشامل لأرقام الموبايل ولوحات السيارات والسيارات',
      mobileNumbers: 'أرقام موبايل',
      carPlates: 'لوحات سيارات',
      cars: 'سيارات',
      recentlyAdded: 'أضيفت مؤخراً',
      viewAll: 'عرض الكل',
      buyNow: 'اشترِ الآن',
      viewDetails: 'عرض التفاصيل',
      activeListings: 'إعلانات نشطة',
      supportAvailable: 'دعم متاح',
      secureTransactions: 'معاملات آمنة',
      allCategories: 'جميع الفئات',
      allPrices: 'جميع الأسعار',
      newest: 'الأحدث',
      priceAsc: 'السعر: من الأقل للأعلى',
      priceDesc: 'السعر: من الأعلى للأقل',
      clearFilters: 'مسح الفلاتر',
      noResults: 'لا توجد نتائج',
      tryDifferent: 'جرب تغيير معايير البحث',
      showing: 'عرض',
      of: 'من',
      results: 'نتيجة',
      items: 'عنصر',
      searchPlaceholder: 'ابحث...',
      allBrands: 'جميع الماركات',
      allYears: 'جميع السنوات',
      allEmirates: 'جميع الإمارات',
      comingSoon: 'قريباً',
      backToMarket: 'العودة للسوق',
      new: 'جديد',
      searchNumber: 'ابحث عن رقم...',
      searchPlate: 'ابحث عن لوحة...',
      searchCar: 'ابحث عن سيارة...',
      lessThan: 'أقل من',
      moreThan: 'أكثر من',
      call: 'اتصل',
      haveToSell: 'هل لديك ما تبيعه؟',
      joinPlatform: 'انضم لمنصتنا وابدأ البيع اليوم',
      registerMerchant: 'سجل كتاجر',
      recentMobile: 'أرقام موبايل أضيفت مؤخراً',
      recentPlates: 'لوحات سيارات أضيفت مؤخراً',
      recentCars: 'سيارات أضيفت مؤخراً',
      km: 'كم'
    },
    // Common
    common: {
      loading: 'جاري التحميل...',
      error: 'حدث خطأ',
      submit: 'إرسال',
      cancel: 'إلغاء',
      save: 'حفظ',
      delete: 'حذف',
      edit: 'تعديل',
      back: 'العودة',
      next: 'التالي',
      previous: 'السابق',
      search: 'بحث',
      filter: 'تصفية',
      sort: 'ترتيب',
      new: 'جديد',
      phone: 'الهاتف',
      email: 'البريد الإلكتروني',
      address: 'العنوان',
      contact: 'تواصل معنا',
      aboutUs: 'من نحن',
      privacyPolicy: 'سياسة الخصوصية',
      terms: 'الشروط والأحكام',
      allRightsReserved: 'جميع الحقوق محفوظة'
    },
    // Footer
    footer: {
      sections: 'الأقسام',
      company: 'الشركة',
      contact: 'تواصل معنا',
      description: 'سوقك العالمي الموثوق لكل شيء'
    },
    // Region selector
    region: {
      changeLanguage: 'تغيير اللغة',
      changeCurrency: 'تغيير العملة',
      country: 'الدولة/المنطقة'
    },
    // Auth
    auth: {
      login: 'تسجيل الدخول',
      loginSubtitle: 'سجّل الدخول إلى حسابك',
      register: 'إنشاء حساب',
      registerSubtitle: 'أنشئ حساب جديد',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      confirmPassword: 'تأكيد كلمة المرور',
      firstName: 'الاسم الأول',
      lastName: 'اسم العائلة',
      forgotPassword: 'نسيت كلمة المرور؟',
      noAccount: 'ليس لديك حساب؟',
      haveAccount: 'لديك حساب بالفعل؟',
      createAccount: 'إنشاء حساب جديد',
      loggingIn: 'جاري تسجيل الدخول...',
      creatingAccount: 'جاري إنشاء الحساب...',
      sendCode: 'إرسال رمز التحقق',
      sending: 'جاري الإرسال...',
      verifyCode: 'تأكيد الرمز',
      verifying: 'جاري التحقق...',
      codeSentTo: 'تم إرسال رمز التحقق إلى',
      enterCode: 'أدخل رمز التحقق (6 أرقام)',
      changeEmail: 'تغيير البريد الإلكتروني',
      emailVerified: 'تم التحقق من البريد',
      enterEmailToStart: 'أدخل بريدك الإلكتروني للبدء',
      enterCodeSent: 'أدخل رمز التحقق المرسل إلى بريدك',
      completeAccount: 'أكمل بيانات حسابك',
      passwordRequirements: 'متطلبات كلمة المرور',
      minChars: '8 أحرف على الأقل',
      uppercase: 'حرف كبير واحد على الأقل (A-Z)',
      lowercase: 'حرف صغير واحد على الأقل (a-z)',
      number: 'رقم واحد على الأقل (0-9)',
      symbol: 'رمز واحد على الأقل (!@#$...)',
      passwordMatch: 'كلمة المرور متطابقة',
      englishOnly: 'يرجى كتابة الاسم بالإنجليزية',
      invalidEmail: 'البريد الإلكتروني غير صحيح'
    },
    // Pages
    pages: {
      aboutTitle: 'من نحن',
      aboutSubtitle: 'تعرف على CloudGM',
      privacyTitle: 'سياسة الخصوصية',
      privacySubtitle: 'كيف نحمي بياناتك',
      termsTitle: 'الشروط والأحكام',
      termsSubtitle: 'شروط استخدام المنصة',
      realEstate: 'العقارات',
      spareParts: 'قطع الغيار',
      products: 'المنتجات',
      comingSoon: 'قريباً',
      stayTuned: 'ترقبوا إطلاق هذا القسم قريباً',
      backToHome: 'العودة للرئيسية'
    },
    // Visa Services
    visa: {
      title: 'خدمات التأشيرة والهوية الإماراتية',
      backToServices: 'العودة',
      allServices: 'جميع الخدمات',
      visaServices: 'خدمات التأشيرة',
      emiratesId: 'الهوية الإماراتية',
      renewals: 'التجديدات',
      medical: 'الطبية',
      applyNow: 'تقديم طلب',
      processingTime: 'مدة المعالجة',
      workDays: 'أيام عمل',
      applicationForm: 'نموذج تقديم الطلب',
      personalInfo: 'المعلومات الشخصية',
      passportInfo: 'معلومات جواز السفر',
      contactInfo: 'معلومات التواصل',
      sponsorInfo: 'معلومات الكفيل (اختياري)',
      uploadDocs: 'رفع المستندات',
      fullNameAr: 'الاسم الكامل (بالعربية)',
      fullNameEn: 'الاسم الكامل (بالإنجليزية)',
      dateOfBirth: 'تاريخ الميلاد',
      gender: 'الجنس',
      male: 'ذكر',
      female: 'أنثى',
      maritalStatus: 'الحالة الاجتماعية',
      single: 'أعزب/عزباء',
      married: 'متزوج/متزوجة',
      divorced: 'مطلق/مطلقة',
      widowed: 'أرمل/أرملة',
      nationality: 'الجنسية',
      passportNumber: 'رقم جواز السفر',
      passportExpiry: 'تاريخ انتهاء الجواز',
      currentVisaStatus: 'حالة التأشيرة الحالية',
      visitVisa: 'تأشيرة زيارة',
      employmentVisa: 'تأشيرة عمل',
      residence: 'إقامة',
      expired: 'منتهية',
      none: 'لا يوجد',
      sponsorName: 'اسم الكفيل',
      sponsorUid: 'رقم الهوية الإماراتية للكفيل',
      passportCopy: 'صورة جواز السفر',
      personalPhoto: 'صورة شخصية',
      emiratesIdCopy: 'صورة الهوية الإماراتية',
      additionalDocs: 'مستندات إضافية',
      additionalNotes: 'ملاحظات إضافية',
      confirmSubmit: 'تأكيد وإرسال الطلب',
      submitting: 'جاري إرسال الطلب...',
      termsNote: 'بالضغط على "تأكيد وإرسال الطلب" فإنك توافق على شروط الخدمة وسياسة الخصوصية',
      requestedService: 'الخدمة المطلوبة',
      price: 'السعر',
      uploadNote: 'يرجى رفع صور واضحة من المستندات التالية (PDF أو صورة، الحد الأقصى 5MB)',
      fileUploaded: 'تم رفع الملف بنجاح',
      fileSizeError: 'حجم الملف يجب أن يكون أقل من 5 ميجابايت',
      fillRequired: 'يرجى ملء جميع الحقول المطلوبة',
      requestSuccess: 'تم إرسال طلبك بنجاح! سيتواصل معك فريقنا قريباً',
      requestError: 'حدث خطأ في إرسال الطلب'
    },
    // Translation Services
    translationPage: {
      title: 'خدمات الترجمة القانونية',
      backToServices: 'العودة للخدمات',
      description: 'خدمات ترجمة معتمدة ومحترفة لجميع أنواع المستندات القانونية والرسمية',
      startService: 'ابدأ الخدمة',
      fullName: 'الاسم الكامل',
      requestDetails: 'تفاصيل الطلب',
      requestDetailsPlaceholder: 'اكتب تفاصيل المستندات المطلوب ترجمتها...',
      whyChooseUs: 'لماذا تختارنا؟',
      fastDelivery: 'سرعة التسليم',
      fastDeliveryDesc: 'تسليم الترجمات في أسرع وقت ممكن',
      certifiedQuality: 'جودة معتمدة',
      certifiedQualityDesc: 'ترجمات معتمدة ومقبولة رسمياً',
      expertTranslators: 'مترجمون خبراء',
      expertTranslatorsDesc: 'فريق من المترجمين المحترفين المعتمدين',
      certifiedTranslation: 'ترجمة معتمدة',
      officiallyAccepted: 'مقبولة رسمياً',
      allLanguages: 'جميع اللغات',
      certifiedTranslators: 'مترجمين معتمدين',
      legalAccuracy: 'دقة قانونية',
      confidential: 'سرية تامة',
      officialAttestation: 'توثيق رسمي',
      academicCerts: 'شهادات أكاديمية',
      personalCerts: 'شهادات شخصية',
      financialReports: 'تقارير مالية',
      commercialContracts: 'عقود تجارية',
      corporateDocs: 'مستندات شركات',
      guaranteedConfidential: 'سرية مضمونة',
      startsFrom: 'يبدأ من'
    },
    // Document Services
    documentPage: {
      title: 'الطباعة وتخليص المستندات',
      description: 'خدمات طباعة وتخليص مستندات سريعة وموثوقة للدوائر الحكومية',
      startService: 'ابدأ الخدمة'
    },
    // Company Formation
    companyPage: {
      title: 'تأسيس الشركات',
      description: 'حلول شاملة لإنشاء وتأسيس الشركات في الإمارات',
      startService: 'ابدأ الخدمة'
    },
    // Loyalty Program
    loyalty: {
      title: 'برنامج الولاء',
      subtitle: 'انضم لبرنامج CloudGM للولاء واستمتع بمزايا حصرية',
      description: 'اكسب نقاط مع كل عملية واستبدلها بخصومات ومكافآت رائعة',
      tiers: 'مستويات العضوية',
      blue: 'الأزرق',
      silver: 'الفضي',
      gold: 'الذهبي',
      platinum: 'البلاتيني',
      blueDesc: 'المستوى الأساسي لجميع الأعضاء الجدد',
      silverDesc: 'للأعضاء النشطين مع مزايا إضافية',
      goldDesc: 'للأعضاء المميزين مع خصومات حصرية',
      platinumDesc: 'أعلى مستوى مع مزايا VIP',
      joinNow: 'انضم الآن',
      learnMore: 'اعرف المزيد'
    }
  },
  en: {
    // Navigation
    nav: {
      services: 'Services',
      realEstate: 'Real Estate',
      marketplace: 'Marketplace',
      spareParts: 'Spare Parts',
      products: 'Shop',
      login: 'Login',
      register: 'Register',
      dashboard: 'Dashboard',
      logout: 'Logout'
    },
    // Home page
    home: {
      heroTitle: 'All Your Services in One Place',
      heroSubtitle: 'Your comprehensive platform for everything you need in one place',
      getStarted: 'Get Started',
      learnMore: 'Learn More',
      exploreCategories: 'Explore Categories',
      exploreCategoriesSubtitle: 'Discover a variety of services and products',
      featuredServices: 'Our Featured Services',
      whyChooseUs: 'Why Choose Us?',
      merchantTitle: 'Are you a merchant?',
      merchantSubtitle: 'Join CloudGM Business and reach thousands of customers',
      joinBusiness: 'Join CloudGM Business',
      servicesTitle: 'Professional Services',
      servicesDesc: 'Comprehensive solutions for all your needs',
      realEstateTitle: 'Property & Lands',
      realEstateDesc: 'Discover premium properties and lands in UAE',
      storeTitle: 'Online Store',
      storeDesc: 'Shop from a wide range of high-quality products',
      marketplaceTitle: 'MarketPlace Hub',
      marketplaceDesc: 'Mobile numbers, vehicles, and premium plates',
      sparePartsTitle: 'Auto Spare Parts',
      sparePartsDesc: 'High-quality spare parts for all vehicles'
    },
    // Services
    services: {
      title: 'Government Services',
      subtitle: 'الخدمات الحكومية',
      description: 'Comprehensive government services with the highest quality standards',
      visa: 'Visa & Emirates ID Services',
      translation: 'Legal Translation',
      documents: 'Document Clearing',
      companyFormation: 'Company Formation',
      subscriptionPackages: 'Subscription Packages',
      monthly: 'Monthly',
      yearly: 'Yearly',
      subscribe: 'Subscribe Now',
      mostPopular: 'Most Popular',
      recommended: 'Recommended',
      save: 'Save',
      exploreService: 'Explore Service',
      comingSoon: 'Coming Soon',
      requestService: 'Request Service',
      serviceType: 'Service Type',
      requestTitle: 'Request Title',
      details: 'Details',
      name: 'Name',
      submitRequest: 'Submit Request',
      submitting: 'Submitting...',
      packageFeatures: 'Package Features',
      confirmSubscription: 'Confirm Subscription',
      fullNameOrCompany: 'Full Name / Company Name',
      subscribeIn: 'Subscribe to'
    },
    // Marketplace
    marketplace: {
      title: 'Marketplace',
      subtitle: 'السوق',
      description: 'Discover our comprehensive marketplace for mobile numbers, car plates, and cars',
      mobileNumbers: 'Mobile Numbers',
      carPlates: 'Car Plates',
      cars: 'Cars',
      recentlyAdded: 'Recently Added',
      viewAll: 'View All',
      buyNow: 'Buy Now',
      viewDetails: 'View Details',
      activeListings: 'Active Listings',
      supportAvailable: 'Support Available',
      secureTransactions: 'Secure Transactions',
      allCategories: 'All Categories',
      allPrices: 'All Prices',
      newest: 'Newest',
      priceAsc: 'Price: Low to High',
      priceDesc: 'Price: High to Low',
      clearFilters: 'Clear Filters',
      noResults: 'No Results',
      tryDifferent: 'Try different search criteria',
      showing: 'Showing',
      of: 'of',
      results: 'results',
      items: 'items',
      searchPlaceholder: 'Search...',
      allBrands: 'All Brands',
      allYears: 'All Years',
      allEmirates: 'All Emirates',
      comingSoon: 'Coming Soon',
      backToMarket: 'Back to Market',
      new: 'New',
      searchNumber: 'Search for number...',
      searchPlate: 'Search for plate...',
      searchCar: 'Search for car...',
      lessThan: 'Less than',
      moreThan: 'More than',
      call: 'Call',
      haveToSell: 'Have something to sell?',
      joinPlatform: 'Join our platform and start selling today',
      registerMerchant: 'Register as Merchant',
      recentMobile: 'Recently Added Mobile Numbers',
      recentPlates: 'Recently Added Car Plates',
      recentCars: 'Recently Added Cars',
      km: 'km'
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'An error occurred',
      submit: 'Submit',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      search: 'Search',
      filter: 'Filter',
      sort: 'Sort',
      new: 'New',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      contact: 'Contact Us',
      aboutUs: 'About Us',
      privacyPolicy: 'Privacy Policy',
      terms: 'Terms of Service',
      allRightsReserved: 'All rights reserved'
    },
    // Footer
    footer: {
      sections: 'Sections',
      company: 'Company',
      contact: 'Contact Us',
      description: 'Your trusted global marketplace for everything'
    },
    // Region selector
    region: {
      changeLanguage: 'Change Language',
      changeCurrency: 'Change Currency',
      country: 'Country/Region'
    },
    // Auth
    auth: {
      login: 'Login',
      loginSubtitle: 'Login to Your Account',
      register: 'Register',
      registerSubtitle: 'Create a New Account',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      firstName: 'First Name',
      lastName: 'Last Name',
      forgotPassword: 'Forgot Password?',
      noAccount: "Don't have an account?",
      haveAccount: 'Already have an account?',
      createAccount: 'Create New Account',
      loggingIn: 'Logging in...',
      creatingAccount: 'Creating account...',
      sendCode: 'Send Verification Code',
      sending: 'Sending...',
      verifyCode: 'Verify Code',
      verifying: 'Verifying...',
      codeSentTo: 'Verification code sent to',
      enterCode: 'Enter verification code (6 digits)',
      changeEmail: 'Change Email',
      emailVerified: 'Email Verified',
      enterEmailToStart: 'Enter your email to get started',
      enterCodeSent: 'Enter the code sent to your email',
      completeAccount: 'Complete your account details',
      passwordRequirements: 'Password Requirements',
      minChars: 'At least 8 characters',
      uppercase: 'At least one uppercase letter (A-Z)',
      lowercase: 'At least one lowercase letter (a-z)',
      number: 'At least one number (0-9)',
      symbol: 'At least one symbol (!@#$...)',
      passwordMatch: 'Passwords match',
      englishOnly: 'Please enter name in English',
      invalidEmail: 'Invalid email address'
    },
    // Pages
    pages: {
      aboutTitle: 'About Us',
      aboutSubtitle: 'Learn about CloudGM',
      privacyTitle: 'Privacy Policy',
      privacySubtitle: 'How we protect your data',
      termsTitle: 'Terms of Service',
      termsSubtitle: 'Platform usage terms',
      realEstate: 'Real Estate',
      spareParts: 'Spare Parts',
      products: 'Products',
      comingSoon: 'Coming Soon',
      stayTuned: 'Stay tuned for the launch of this section',
      backToHome: 'Back to Home'
    },
    // Visa Services
    visa: {
      title: 'Visa & Emirates ID Services',
      backToServices: 'Back',
      allServices: 'All Services',
      visaServices: 'Visa Services',
      emiratesId: 'Emirates ID',
      renewals: 'Renewals',
      medical: 'Medical',
      applyNow: 'Apply Now',
      processingTime: 'Processing Time',
      workDays: 'Working Days',
      applicationForm: 'Application Form',
      personalInfo: 'Personal Information',
      passportInfo: 'Passport Information',
      contactInfo: 'Contact Information',
      sponsorInfo: 'Sponsor Information (Optional)',
      uploadDocs: 'Upload Documents',
      fullNameAr: 'Full Name (Arabic)',
      fullNameEn: 'Full Name (English)',
      dateOfBirth: 'Date of Birth',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      maritalStatus: 'Marital Status',
      single: 'Single',
      married: 'Married',
      divorced: 'Divorced',
      widowed: 'Widowed',
      nationality: 'Nationality',
      passportNumber: 'Passport Number',
      passportExpiry: 'Passport Expiry Date',
      currentVisaStatus: 'Current Visa Status',
      visitVisa: 'Visit Visa',
      employmentVisa: 'Employment Visa',
      residence: 'Residence',
      expired: 'Expired',
      none: 'None',
      sponsorName: 'Sponsor Name',
      sponsorUid: 'Sponsor Emirates ID',
      passportCopy: 'Passport Copy',
      personalPhoto: 'Personal Photo',
      emiratesIdCopy: 'Emirates ID Copy',
      additionalDocs: 'Additional Documents',
      additionalNotes: 'Additional Notes',
      confirmSubmit: 'Confirm & Submit',
      submitting: 'Submitting...',
      termsNote: 'By clicking "Confirm & Submit" you agree to our Terms of Service and Privacy Policy',
      requestedService: 'Requested Service',
      price: 'Price',
      uploadNote: 'Please upload clear copies of the following documents (PDF or image, max 5MB)',
      fileUploaded: 'File uploaded successfully',
      fileSizeError: 'File size must be less than 5MB',
      fillRequired: 'Please fill all required fields',
      requestSuccess: 'Your request has been submitted! Our team will contact you soon',
      requestError: 'Error submitting request'
    },
    // Translation Services
    translationPage: {
      title: 'Legal Translation Services',
      backToServices: 'Back to Services',
      description: 'Certified and professional translation services for all types of legal and official documents',
      startService: 'Start Service',
      fullName: 'Full Name',
      requestDetails: 'Request Details',
      requestDetailsPlaceholder: 'Enter details of documents to be translated...',
      whyChooseUs: 'Why Choose Us?',
      fastDelivery: 'Fast Delivery',
      fastDeliveryDesc: 'Deliver translations as fast as possible',
      certifiedQuality: 'Certified Quality',
      certifiedQualityDesc: 'Certified translations officially accepted',
      expertTranslators: 'Expert Translators',
      expertTranslatorsDesc: 'Team of certified professional translators',
      certifiedTranslation: 'Certified Translation',
      officiallyAccepted: 'Officially Accepted',
      allLanguages: 'All Languages',
      certifiedTranslators: 'Certified Translators',
      legalAccuracy: 'Legal Accuracy',
      confidential: 'Confidential',
      officialAttestation: 'Official Attestation',
      academicCerts: 'Academic Certificates',
      personalCerts: 'Personal Certificates',
      financialReports: 'Financial Reports',
      commercialContracts: 'Commercial Contracts',
      corporateDocs: 'Corporate Documents',
      guaranteedConfidential: 'Guaranteed Confidential',
      startsFrom: 'Starts from'
    },
    // Document Services
    documentPage: {
      title: 'Typing & Document Clearing',
      description: 'Fast and reliable document typing and clearing services for government departments',
      startService: 'Start Service'
    },
    // Company Formation
    companyPage: {
      title: 'Company Formation',
      description: 'Complete solutions for company formation and setup in UAE',
      startService: 'Start Service'
    },
    // Loyalty Program
    loyalty: {
      title: 'Loyalty Program',
      subtitle: 'Join CloudGM Loyalty Program and enjoy exclusive benefits',
      description: 'Earn points with every transaction and redeem them for great discounts and rewards',
      tiers: 'Membership Tiers',
      blue: 'Blue',
      silver: 'Silver',
      gold: 'Gold',
      platinum: 'Platinum',
      blueDesc: 'Basic tier for all new members',
      silverDesc: 'For active members with additional benefits',
      goldDesc: 'For premium members with exclusive discounts',
      platinumDesc: 'Highest tier with VIP benefits',
      joinNow: 'Join Now',
      learnMore: 'Learn More'
    }
  }
};

// Create context
const LanguageContext = createContext();

// Provider component
export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('ar');

  useEffect(() => {
    // Get saved language from localStorage
    const savedLang = localStorage.getItem('cloudgm_lang') || 'ar';
    setLanguage(savedLang);
    document.documentElement.setAttribute('dir', savedLang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', savedLang);
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('cloudgm_lang', lang);
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lang);
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const isRTL = language === 'ar';

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, isRTL, translations: translations[language] }}>
      {children}
    </LanguageContext.Provider>
  );
}

// Hook to use language
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

export { translations };
